import { render, staticRenderFns } from "./QrCodeDialog.vue?vue&type=template&id=edfd90a4&scoped=true&"
import script from "./QrCodeDialog.vue?vue&type=script&lang=js&"
export * from "./QrCodeDialog.vue?vue&type=script&lang=js&"
import style0 from "./QrCodeDialog.vue?vue&type=style&index=0&id=edfd90a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfd90a4",
  null
  
)

export default component.exports